import { render, staticRenderFns } from "./another-person.vue?vue&type=template&id=0a01fa44&lang=pug&"
import script from "./another-person.vue?vue&type=script&lang=js&"
export * from "./another-person.vue?vue&type=script&lang=js&"
import style0 from "./another-person.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports